import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[appCellTemplate]',
})
export class CellTemplateDirective {
  @Input('appCellTemplate') name!: string;

  constructor(public template: TemplateRef<any>) {}
}
